import { render } from "./aboutmenu.vue?vue&type=template&id=13a7bb66"
import script from "./aboutmenu.vue?vue&type=script&lang=js"
export * from "./aboutmenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__